import { Button, makeStyles, MessageBar, MessageBarActions, MessageBarBody } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { FeedbackMessageIntent, IFeedbackMessage } from '../../contexts/feedbackMessagesContext';
import { customPalette } from '../../theme';

export interface ICustomMessageBarProps {
    message: string | React.ReactNode;
    type: FeedbackMessageIntent;
    setActiveMessage: (message: IFeedbackMessage | undefined) => void;
}

const useStyles = makeStyles({
    errorRoot: {
        backgroundColor: customPalette.errorBackground,
    },
});

/** Matches Fluent 8 MessageBar role mapping: error → alert; info/success/warning → status. */
function getMessageBarRole(intent: FeedbackMessageIntent): 'alert' | 'status' {
    return intent === 'error' ? 'alert' : 'status';
}

export function CustomMessageBar(props: ICustomMessageBarProps) {
    const styles = useStyles();

    return (
        <MessageBar
            intent={props.type}
            className={props.type === 'error' ? styles.errorRoot : undefined}
            role={getMessageBarRole(props.type)}
        >
            <MessageBarBody>{props.message}</MessageBarBody>
            <MessageBarActions
                containerAction={
                    <Button
                        appearance='transparent'
                        icon={<DismissRegular />}
                        onClick={() => props.setActiveMessage(undefined)}
                        aria-label='Close'
                    />
                }
            />
        </MessageBar>
    );
}
